<template>
  <sfs-form-modal
    :id="modalId"
    title="Edit Additional Info"
    :size="form.customFieldValues.length > 3 ? 'lg' : 'sm'"
  >
    <b-form @submit.stop.prevent="handleSubmit">
      <b-row>
        <b-col>
          <b-alert
            :show="hasBaseServerErrors()"
            variant="danger"
            dismissible
          >
            <p
              class="mb-0"
              v-for="(error, index) in baseServerErrors"
              :key="index"
            >
              {{ error }}
            </p>
          </b-alert>
        </b-col>
      </b-row>

      <b-row v-if="form.customFieldValues.length === 0">
        <b-col class="mt-3">
          <p class="text-muted">
            There are no additional fields available.
          </p>
        </b-col>
      </b-row>

      <b-row>
        <b-col
          v-for="(v, index) in $v.form.customFieldValues.$each.$iter"
          :key="index"
          :cols="form.customFieldValues.length > 3 ? 6 : 12"
        >
          <form-field
            :custom-field="v.custom_field.$model"
            v-model="v.value.$model"
            :validation-class="{ 'is-invalid': v.value.$dirty && v.value.$error }"
            :time-zone="timeZone"
          >
            <template #feedback>
              <b-form-invalid-feedback
                v-if="v.value.$dirty"
                class="custom-field-values-form-value-feedback"
              >
                <span v-if="!v.value.serverFailed">{{ serverErrors.value }}</span>
              </b-form-invalid-feedback>
            </template>
          </form-field>
        </b-col>
      </b-row>

      <hr class="mt-4">

      <b-row>
        <b-col
          offset-lg="6"
          lg="3"
          order="2"
          order-lg="1"
        >
          <b-button
            variant="link-dark"
            block
            id="custom-field-values-form-close-button"
            @click="closeModal"
          >
            Cancel
          </b-button>
        </b-col>
        <b-col
          lg="3"
          order="1"
          order-lg="2"
        >
          <b-button
            id="custom-field-values-form-submit-button"
            block
            type="submit"
            variant="primary"
            :disabled="processing"
          >
            Save
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </sfs-form-modal>
</template>

<script>
import { isNil as _isNil } from 'lodash';
import formMixin from '@/mixins/formMixin';
import formModalMixin from '@/mixins/formModalMixin';
import FormField from '@/components/admin/customFields/FormField';
import { WORK_ORDER_MODEL_TYPE, LOCATION_MODEL_TYPE  } from '@/constants/customFields';
export default {
  name: 'CustomFieldValuesFormModal',
  mixins: [formMixin, formModalMixin],
  components: {
    FormField,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    modelType: {
      type: String,
      default: WORK_ORDER_MODEL_TYPE
    },
    customFieldValues: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: {
        customFieldValues: [],
      },
      modalId: 'custom-field-values-form-modal',
    };
  },
  validations: {
    form: {
      customFieldValues: {
        $each: {
          value: {
            serverFailed() {
              return !this.hasServerErrors('value');
            },
          },
          field_type: {},
          custom_field: {},
          custom_field_id: {},
        },
      },
    },
  },
  mounted() {
    this.getCustomFields();
  },
  computed: {
    listEndpoint() {
      return this.isWorkOrderForm ? this.$customFieldsAPI.getWorkOrderOptions : this.$customFieldsAPI.getLocationOptions;
    },
    manageEndpoint() {
      return this.isWorkOrderForm ? this.$customFieldsAPI.manageWorkOrderValues : this.$customFieldsAPI.manageLocationValues;
    },
    isWorkOrderForm() {
      return this.modelType === WORK_ORDER_MODEL_TYPE;
    },
    timeZone() {
      return this.modelType === LOCATION_MODEL_TYPE ? this.value.time_zone : this.value.location?.time_zone;
    }
  },
  methods: {
    getCustomFields() {
      this.listEndpoint(this.value.id).then(({ customFields }) => {
        this.form.customFieldValues = customFields.map((customField) => ({
          value: this.getPropValue(customField.id),
          custom_field: customField,
          custom_field_id: customField.id,
          field_type: customField.field_type,
        }));
        this.$emit('data-changed', customFields);
      });
    },
    getPropValue(customFieldId) {
      return this.customFieldValues.find((customFieldValue) => customFieldValue.custom_field_id === customFieldId)?.value;
    },
    handleSubmit() {
      if (this.hasFormErrors()) {
        return;
      }
      const customFieldValues = this.form.customFieldValues.filter((fieldValue) => {
        return !(_isNil(fieldValue.value) || fieldValue.value === '');
      });
      this.manageEndpoint(this.value.id, { custom_field_values_attributes: customFieldValues })
        .then(({ customFieldValues }) => {
          this.resetServerErrors();
          this.$v.$reset();
          this.$emit('input', customFieldValues);
          this.closeModal();
        })
        .catch((error) => {
          this.processServerErrors(error.response.data.errors);
        });
    },
  },
};
</script>
